<template>
	<div class="home" :class="[active === 2 ? 'bg-white' : '']">
		<transition name="van-fade" mode="out-in">
			<component @changeTab="changeTab" :is="list[active].component"></component>
		</transition>

		<!--此部分内容为占位内容  仅仅只是占位-->
		<van-tabbar class="hide" :fixed="false" safe-area-inset-bottom>
			<van-tabbar-item>
				<template #icon>
					<img src="@/assets/icon/icon_home_tab_1.png" />
				</template>
				<span class="tab_title">站位内容</span>
			</van-tabbar-item>
		</van-tabbar>

		<van-tabbar :value="active" safe-area-inset-bottom>
			<van-tabbar-item
				v-for="(item, index) in list"
				:key="`tabs_${ item.id }`"
				@click="clickToggleTab(item, index)"
			>
				<template #icon="props">
					<van-badge class="bottom-badge">
						<template #content>
							<img
								v-if="item.id==='information'&&showTag"
								class="badge_image"
								src="../../assets/icon/new.png"
							/>
						</template>
						<img :src="props.active ? item.icon[1] : item.icon[0]" />
					</van-badge>
				</template>
				<span class="tab_title">{{ item.title }}</span>
			</van-tabbar-item>
		</van-tabbar>

		<!-- <div class="consult" v-drag @click.prevent="$router.push('/im')">
			<div>
				<div class="icon"><img src="@/assets/icon/icon_course.png" alt="" /></div>
				<span class="label">咨询</span>
			</div>
		</div> -->
	</div>
</template>

<script>
import HomeHealth from '../health/home.vue'
import HomePhysicianVisits from '../physician-visits/home.vue'
import HomeMy from '../my/home.vue'
import HomeInformation from '../information/home.vue'
export default {
    name: 'home',
    components: { HomeHealth, HomeMy, HomePhysicianVisits, HomeInformation },
    data: () => ({
        active: 0,
        list: [
            { id: 'visits', title: '首页', icon: [require('@/assets/icon/icon_home_tab_1.png'), require('@/assets/icon/icon_home_tab_1_primary.png')], component: 'HomePhysicianVisits' },
            { id: 'health', title: '指标监测', icon: [require('@/assets/icon/icon_home_tab_2.png'), require('@/assets/icon/icon_home_tab_2_primary.png')], component: 'HomeHealth' },
            { id: 'information', title: '科普患教', icon: [require('@/assets/icon/icon_home_tab_3.png'), require('@/assets/icon/icon_home_tab_3_primary.png')], component: 'HomeInformation' },
            { id: 'my', title: '我的', icon: [require('@/assets/icon/icon_home_tab_4.png'), require('@/assets/icon/icon_home_tab_4_primary.png')], component: 'HomeMy' }
        ],
        doctorId: ''
    }),
    computed: {
        showTag () {
            const { patientEducationStatus, popularStatus } = this.$store.getters['information/getInformationState']

            return patientEducationStatus || popularStatus
        }
    },
    activated () {
        this.init()
    },
    created () {
        this.init()
    },
    directives: {
        drag (el) {
            el.ontouchstart = e => {
                //算出鼠标相对元素的位置
                el.style.transition = 'none'
                const disX = e.touches[0].clientX - el.offsetLeft
                const disY = e.touches[0].clientY - el.offsetTop
                el.ontouchmove = e => {
                    e.preventDefault()
                    //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                    let left = e.touches[0].clientX - disX
                    let top = e.touches[0].clientY - disY
                    if (left < 0) left = 0
                    if (top < 0) top = 0
                    //移动当前元素
                    el.style.right = window.innerWidth - left - el.offsetWidth + 'px'
                    el.style.bottom = window.innerHeight - top - el.offsetHeight + 'px'
                }
                el.ontouchend = () => {
                    el.style.transition = 'all .3s ease-out'
                    el.style.right = ''
                    if (Number.parseFloat(el.style.bottom) < window.innerHeight - (window.innerHeight - el.offsetHeight - 50)) {
                        el.style.bottom = ''
                    }
                    if (Number.parseFloat(el.style.bottom) > (window.innerHeight - el.offsetHeight - 50)) {
                        el.style.bottom = window.innerHeight - el.offsetHeight - 50 + 'px'
                    }
                    el.ontouchmove = null
                    el.ontouchend = null
                }
            }
        }
    },
    methods: {
        init () {
            if (this.$route.params.type) {
                const index = this.list.findIndex(item => item.id === this.$route.params.type)
                this.active = index > -1 ? index : 0
            } else { this.active = 0 }
            document.title = this.list[this.active].title

        },
        clickToggleTab (item, index) {
            if (this.$route.params.type !== item.id) {
                this.active = index
                document.title = item.title
                this.$router.replace(`/main/home/${item.id}`)
            }
        },
        changeTab (type) {
            const index = this.list.findIndex(item => item.id === type)
            this.active = index
            this.$router.replace(`/main/home/${type}`)
        }
    }
};
</script>

<style scoped lang="less">
.home {
	min-height: calc(100vh - 20px);
	padding-bottom: 20px;
	.tab_title {
		font-size: 22px;
		line-height: 26px;
		font-family: PingFangSC-Regular;
	}
	.btn + .btn {
		margin-top: 20px;
	}

	.consult {
		position: fixed;
		right: 36px;
		bottom: 248px;
		width: 92px;
		height: 92px;
		box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.08);
		text-align: center;
		border-radius: 50%;
		background-color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		.icon {
			> img {
				width: 33.33px;
				height: 33.33px;
			}
		}
		.label {
			height: 28px;
			font-family: PingFangSC-Regular;
			font-size: 20px;
			font-weight: normal;
			color: #1f2329;
		}
	}
}
</style>
<style lang="less">
.bottom-badge {
	z-index: 999;
	.van-badge--fixed {
		right: -2px;
	}
	.van-badge {
		background-color: transparent;
		line-height: 1;
		border: 0;
		border-radius: 0;
		padding: 0;
		.badge_image {
			width: 63px;
			height: 32px;
		}
	}
}
</style>
